import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpEvent} from "@angular/common/http";
import {Observable} from "rxjs";
import {baseUrl} from "../../../../../../core/constants/base-url";
import {emptyHttpHeaders} from "../../../../../../core/models/http-headers";
import {UploadProductPackagesExcelParams} from "../types/upload-packages-excel.types";

@Injectable({
  providedIn: 'root'
})
export class UploadPackagesExcelApiService {
  private http: HttpClient = inject(HttpClient);

  public importProductPackagesExcel(uploadProductPackagesExcelParams: UploadProductPackagesExcelParams): Observable<HttpEvent<void>> {
    const { path, file } = uploadProductPackagesExcelParams;

    return this.http.post<void>(`${baseUrl}/${path}`, file, {
      reportProgress: true,
      observe: 'events',
      headers: emptyHttpHeaders
    });
  }
}
